import { render, staticRenderFns } from "./ModalConfirmComponent.vue?vue&type=template&id=33c97a8e"
import script from "./ModalConfirmComponent.vue?vue&type=script&lang=js"
export * from "./ModalConfirmComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports